import * as Styled from "./style";
import type { Maybe } from "~/lib/graphql";

type Props = {
  price: number;
  salePrice?: Maybe<number>;
  isMultiPrice: boolean;
};

export const NormalPrice = (props: Props) => {
  const { price, salePrice, isMultiPrice } = props;
  const rangeSymbol = isMultiPrice ? "〜" : "";
  const priceText = `${price.toLocaleString()}円`;
  const salePriceText = `${salePrice?.toLocaleString()}円`;

  return (
    <>
      {salePrice ? (
        <>
          <Styled.SpanOriginalPrice isStrikethrough={true}>{priceText}</Styled.SpanOriginalPrice>
          <Styled.SpanSalePrice>{`${salePriceText}${rangeSymbol}`}</Styled.SpanSalePrice>
        </>
      ) : (
        <Styled.SpanOriginalPrice>{`${priceText}${rangeSymbol}`}</Styled.SpanOriginalPrice>
      )}
    </>
  );
};
